import React, { PropTypes } from "react";
import { inject, observer } from "mobx-react/index";
import Spinner from "../../Spinner";
import Form, {
  FormBody,
  TextInput,
  SelectInput,
  FormActions,
  SwitchInput,
} from "../../Form";
import Modal from "../../Modal";
import { observable, action, toJS } from "mobx";
import moment from "moment";
import { token } from "../../../libs/localStorage";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import CronIntervalInput from "../../CronIntervalInput";
import IntervalInput from '../../Form/IntervalInput';

@inject(
  "eventTypeStore",
  "eventStore",
  "stationStore",
  "userStore",
  "ticketStatusStore",
  "ticketReasonStore",
  "ticketActionStore",
  "qcCheckStore"
)
@observer
class EventModify extends React.Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  title = '';
  slug = "/monitoring/event/list";

  @observable editMode = false;
  @observable event = {
    caption: "",
    event_type: "",
    max_occurrence: "",
    duration: "",
    interval: "",
  };

  @observable event_ticket = {
    generated_date: moment().format("YYYY-MM-DDTHH:mm:ss"),
    status_id: null,
    reason_id: null,
    action_id: null,
    user_id: +token.getDecoded().id,
    summary: "",
    description: "",
    station_id: this.props.station_id || null,
    assigned_to: null,
    name: "",
    mobile_no: "",
    email_address: "",
    valid_days: null,
    sms_notify: false,
  };

  @observable multiStationOptions = [];
  @observable multiQCCheckOptions = [];
  @observable multiUserOptions = [];
  @observable selectedTab = "Event";

  componentWillMount() {
    const { params: { id } } = this.props;
    this.editMode = id !== 'add';
    this.title = this.editMode ? 'Edit Event' : 'Add Event';
    this.populateOptions();
  }

  @action populateOptions = () => {
    const { stationStore, qcCheckStore, userStore, eventStore, eventTypeStore, params: { id } } = this.props;
    let checks = [], followers = [];

    if (this.editMode) {
      const foundItem = eventStore.findById(id);
      if (foundItem) {
        this.event = {
          caption: foundItem.caption,
          event_type: foundItem.event_type,
          max_occurrence: foundItem.max_occurrence,
          duration: foundItem.duration,
          interval: foundItem.interval,
        };

        this.event_ticket = {
          generated_date: foundItem.generated_date,
          status_id: foundItem.status_id,
          reason_id: foundItem.reason_id,
          action_id: foundItem.action_id,
          user_id: foundItem.user_id,
          summary: foundItem.summary,
          station_id: foundItem.station_id,
          assigned_to: foundItem.assigned_to,
          valid_days: foundItem.valid_days,
          name: foundItem.name,
          mobile_no: foundItem.mobile_no,
          email_address: foundItem.email_address,
          description: foundItem.description,
          sms_notify: foundItem.sms_notify,
        };

        if (foundItem.check_ids) checks = foundItem.check_ids.map((item) => item.check_id.toString());
        foundItem.followers &&
          foundItem.followers.forEach((element) => {
            element.user_id
              ? followers.push(element.user_id.toString())
              : followers.push(element);
          });
        this.eventType = eventTypeStore.findById(foundItem.event_type);
      }
    }
    this.multiStationOptions = stationStore.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        label: item.name,
        value: this.editMode && this.eventType && this.eventType.station_check
          ? checks.includes(item.id.toString())
          : false,
        tags: item.tags,
      };
    });

    this.multiQCCheckOptions = qcCheckStore.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        label: item.name,
        value: this.editMode && this.eventType && this.eventType.qc_check
          ? checks.includes(item.id.toString())
          : false,
      };
    });

    this.multiUserOptions = userStore.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        label: item.name,
        value: this.editMode ? followers.includes(item.id.toString()) : false,
        email: item.email,
        mobile: item.mobile,
      };
    });
  };


  handleSave = (e) => {
    e.preventDefault();
    const { notify, router } = this.context;
    const { eventStore, eventTypeStore, params: { id } } = this.props;

    if (
      !this.event_ticket.status_id ||
      !this.event_ticket.reason_id ||
      !this.event_ticket.action_id ||
      !this.event_ticket.summary ||
      !this.event_ticket.assigned_to ||
      !this.event.event_type ||
      !this.event.duration ||
      !this.event.interval ||
      !this.event_ticket.description
    ) {
      notify.error({ message: "Missing Fields" });
      return;
    }

    let selectedChecks = [];
    let selectedFollowers = [];

    selectedFollowers = this.multiUserOptions
      .filter((item) => item.value === true)
      .map((item) => {
        return {
          user_id: item.id,
          email_address: item.email,
          mobile_no: item.mobile,
        };
      });

    const eventType = eventTypeStore.findById(this.event.event_type);
    if (eventType && eventType.station_check) {
      selectedChecks = this.multiStationOptions.filter((item) => item.value === true).map((item) => ({ check_id: item.id }));
    } else if (eventType && eventType.qc_check) {
      selectedChecks = this.multiQCCheckOptions.filter((item) => item.value === true).map((item) => ({ check_id: item.id }));
    }

    const payload = {
      ...this.event,
      ...this.event_ticket,
      sms_notify: this.event_ticket.sms_notify ? 1 : 0,
      check_ids: selectedChecks,
      followers: selectedFollowers,
    };

    (this.editMode ? eventStore.updateItem(Object.assign({}, payload, { id })) : eventStore.createItem(payload))
      .then(() => {
        notify.success({ message: this.editMode ? 'Event updated.' : "Event added." });
        router.push(this.slug);
      })
      .catch((e) => {
        notify.error({ message: `Error ${e.message}` });
        console.log(e);
      });
  };

  @action onStationOptionClicked = (item) => item.value = !item.value;
  @action onQCOptionClicked = (item) => item.value = !item.value;
  @action onUserOptionClicked = (item) => item.value = !item.value;
  @action onChangeAssignedTo = (e) => {
    this.event_ticket.assigned_to = +e.target.value;
    const user = this.props.userStore.findById(+e.target.value);
    this.event_ticket.name = user.name;
    this.event_ticket.mobile_no = user.mobile;
    this.event_ticket.email_address = user.email;
  };

  render() {
    const {
      stationStore,
      eventTypeStore,
      eventStore,
      userStore,
      ticketStatusStore,
      ticketReasonStore,
      ticketActionStore,
      qcCheckStore,
    } = this.props;
    if (
      eventTypeStore.isLoading ||
      eventStore.isLoading ||
      userStore.isLoading ||
      ticketStatusStore.isLoading ||
      ticketReasonStore.isLoading ||
      ticketActionStore.isLoading ||
      qcCheckStore.isLoading
    )
      return <Spinner />;

    const eventTypeOptions = eventTypeStore.items.map((item) => {
      return { value: item.id, label: item.type };
    });

    const eventType = eventTypeStore.findById(this.event.event_type);

    return (
      <Modal
        title={this.title}
        slug={this.slug}
        handleSave={this.handleSave}
      >
        <div>
          <div className="TabBar TabBarRounded">
            <ul>
              <li
                className={this.selectedTab === "Event" ? "active" : ""}
                onClick={() => (this.selectedTab = "Event")}
              >
                <a>Event</a>
              </li>
              <li
                className={
                  this.selectedTab === "Ticket Template" ? "active" : ""
                }
                onClick={() => (this.selectedTab = "Ticket Template")}
              >
                <a> Ticket Template</a>
              </li>
            </ul>
          </div>

          {this.selectedTab === "Event" && (
            <div>
              <Form>
                <FormBody>
                  <TextInput
                    label="Caption"
                    value={this.event.caption}
                    onChange={(e) => (this.event.caption = e.target.value)}
                  />
                  <SelectInput
                    id="Type"
                    label="Type *"
                    options={eventTypeOptions}
                    fields={{ value: "value", label: "label" }}
                    value={this.event.event_type}
                    onChange={(e) => (this.event.event_type = e.target.value)}
                  />
                  {eventType && eventType.station_check === 1 && (
                    <FormMultiSelectInput
                      id="station-multi-select"
                      label="Stations"
                      optionClicked={this.onStationOptionClicked}
                      isLoading={stationStore.isLoading}
                      options={this.multiStationOptions}
                      filterOptions={stationStore.filterStations}
                    />
                  )}
                  {eventType && eventType.qc_check === 1 && (
                    <FormMultiSelectInput
                      id="qc-check-multi-select"
                      label="QC Checks"
                      optionClicked={this.onQCOptionClicked}
                      isLoading={qcCheckStore.isLoading}
                      options={this.multiQCCheckOptions}
                    />
                  )}
                  {eventType && eventType.qc_check === 1 && (
                    <TextInput
                      label="Max Ocurrence *"
                      type="number"
                      value={this.event.max_occurrence}
                      onChange={(e) =>
                        (this.event.max_occurrence = e.target.value)
                      }
                    />
                  )}
                  <IntervalInput label='Duration *' value={this.event.duration} onChange={e => this.event.duration = e.target.value} inMinutes />
                  <CronIntervalInput
                    value={this.event.interval}
                    label={"Interval *"}
                    onChange={e => this.event.interval = e.target.value}
                    key={`interval`}
                  />
                </FormBody>
                <FormActions>
                  <button onClick={this.handleSave}>Save</button>
                </FormActions>
              </Form>
            </div>
          )}

          {this.selectedTab === "Ticket Template" && (
            <div>
              <Form>
                <FormBody>
                  <SelectInput
                    id={"Status"}
                    label={"Status *"}
                    value={this.event_ticket.status_id}
                    options={ticketStatusStore.items}
                    onChange={(e) =>
                      (this.event_ticket.status_id = +e.target.value)
                    }
                    fields={{
                      label: "caption",
                      value: "id",
                    }}
                  />
                  <SelectInput
                    id={"Reason"}
                    label={"Reason *"}
                    value={this.event_ticket.reason_id}
                    options={ticketReasonStore.items}
                    onChange={(e) =>
                      (this.event_ticket.reason_id = +e.target.value)
                    }
                    fields={{
                      label: "caption",
                      value: "id",
                    }}
                  />
                  <SelectInput
                    id={"Action"}
                    label={"Action *"}
                    value={this.event_ticket.action_id}
                    options={ticketActionStore.items}
                    onChange={(e) =>
                      (this.event_ticket.action_id = +e.target.value)
                    }
                    fields={{
                      label: "caption",
                      value: "id",
                    }}
                  />
                  <TextInput
                    label={"Summary *"}
                    value={this.event_ticket.summary}
                    onChange={(e) => {
                      if (e.target.value.length < 50)
                        this.event_ticket.summary = e.target.value;
                    }}
                  />
                  <TextInput
                    label="Description *"
                    id="Description"
                    value={this.event_ticket.description}
                    onChange={(e) =>
                      (this.event_ticket.description = e.target.value)
                    }
                  />
                  <SelectInput
                    id={"Assigned To"}
                    label={"Assigned To *"}
                    value={this.event_ticket.assigned_to}
                    options={userStore.items}
                    onChange={this.onChangeAssignedTo}
                    fields={{
                      label: "name",
                      value: "id",
                    }}
                  />
                  <FormMultiSelectInput
                    id="followers-multi-select"
                    label="Followers"
                    optionClicked={this.onUserOptionClicked}
                    isLoading={userStore.isLoading}
                    options={this.multiUserOptions}
                  />
                  <SwitchInput
                    label={"Nofify via SMS"}
                    value={this.event_ticket.sms_notify}
                    onChange={(e) =>
                      (this.event_ticket.sms_notify = e.target.checked)
                    }
                  />
                  <TextInput
                    label="No of days allowed"
                    id="No of days allowed"
                    value={this.event_ticket.valid_days}
                    onChange={(e) =>
                      (this.event_ticket.valid_days = e.target.value)
                    }
                  />
                </FormBody>
                <FormActions>
                  <button onClick={this.handleSave}>Save</button>
                </FormActions>
              </Form>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default EventModify;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Event/EventModify.js